// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__28gXw","label":"Radio_label__2Yyy0","checkMark":"Radio_checkMark__R2iMX","disabled":"Radio_disabled__277Eg"};